import * as yup from "yup";

export const createAddErrorTransactionValidationSchema = (transactionTypes) => {
  console.log("transactionTypes: " + JSON.stringify(transactionTypes));
  
  return yup.object().shape({
    transactionReasonID: yup
      .number()
      .typeError("A reason must be chosen")
      .required("A reason must be chosen"),
    notesForBee: yup
      .string()
      .when('transactionReasonID', {
        is: (id) => {
          const transactionType = transactionTypes.find(type => type.id === id);
          return transactionType && transactionType.name.toLowerCase() === 'other';
        },
        then: yup.string()
          .required('Reason Details are required')
          .min(4, 'Reason Details must be at least 4 characters'),
        otherwise: yup.string().notRequired(),
      }),
    notesForAdmin: yup
      .string()
      .notRequired(),
  });
}